<template>
  <section>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>

    <div class="background-section-title">
      <div class="section-title">
        <h2>Financeiro</h2>
      </div>
    </div>

    <div class="section-content">
    <div class="filter-container">
      <b-col class="my-1">
        <b-row class="filter-content">

          <b-col cols="3" class="column date-column">
            <b-form-group label="Data inicial" label-for="date-input">
              <b-form-datepicker id="example-datepicker" v-model="selectedBeginDate" v-on:input="onDateChange()"
                v-bind="labels[locale] || {}" reset-button :locale="locale"></b-form-datepicker>
            </b-form-group>
          </b-col>

          <b-col cols="3" class="column date-column">
            <b-form-group label="Data final" label-for="date-input">
              <b-form-datepicker id="example-datepicker2" v-model="selectedFinalDate" v-on:input="onDateChange()"
                v-bind="labels[locale] || {}" reset-button :locale="locale"></b-form-datepicker>
            </b-form-group>
          </b-col>

          <b-col cols="3" class="column search-column">
            <b-form-group label="Buscar" label-for="search-input">
              <b-input-group size="sm">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input v-model="filterUserFinancialText" v-on:keyup.enter="onUserFinancialSearchClick()"
                  type="search" placeholder="Buscar..."></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="3" class="column export-column">
            <b-form-group label="Exportar" label-for="export-actions">
              <div class="export-actions">
                <div class="total-display">
                  <span class="total-label">Total:</span>
                  <b-badge class="badge total-badge">{{ statementTotal }}</b-badge>
                </div>
                <button class="btn btn-secondary export-btn" @click.prevent="exportData">Gerar arquivo</button>
              </div>
            </b-form-group>
          </b-col>

        </b-row>
      </b-col>
    </div>

    <div class="selection-info" v-if="selectedCheckBox.length > 0">
      <div class="selection-indicator">
        <b-icon icon="check-circle-fill" class="selection-icon"></b-icon>
        <span class="selection-text">
          {{ selectedCheckBox.length }} item{{ selectedCheckBox.length > 1 ? 's' : '' }} selecionado{{ selectedCheckBox.length > 1 ? 's' : '' }}
        </span>
        <span class="selection-details">
          - Período: {{ selectedBeginDate ? formatDateDisplay(selectedBeginDate) : 'Não definido' }} até {{ selectedFinalDate ? formatDateDisplay(selectedFinalDate) : 'Não definido' }}
        </span>
      </div>
    </div>

    <div class="tableContainer">

      <b-table :items="users" :fields="fields" :select-mode="multi" responsive="sm" ref="selectableTable" selectable
        @row-selected="onRowSelected">
        <!-- Example scoped slot for select state illustrative purposes -->
        <template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
      </b-table>

      <div class="pagnation">
        <b-col sm="7" md="6" class="my-1">
          <b-pagination @input="updateFinancialPage()" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
            align="fill" size="sm" class="my-0"></b-pagination>
        </b-col>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import { userService } from '../services/user_service';
  import { storeService } from '../services/store.service';
  import doneIcon from '@/assets/icons/done.svg';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import moment from 'moment';
  import * as xlsx from 'xlsx/xlsx.mjs';
  export default {
    name: 'Financial',
    components: {
      Loading
    },
    data () {
      return {
        doneIcon,
        locale: 'pt-BR',
        labels: {
          'pt-BR': {
            labelPrevDecade: 'Década anterior',
            labelPrevYear: 'Ano passado',
            labelPrevMonth: 'Mês passado',
            labelCurrentMonth: 'Mês atual',
            labelNextMonth: 'Próximo mês',
            labelNextYear: 'Próximo ano',
            labelNextDecade: 'Próxima década',
            labelToday: 'Hoje',
            labelSelected: 'Data selecionada',
            labelNoDateSelected: 'Selecione uma data',
            labelCalendar: 'Calendário',
            labelNav: 'Navegação do calendário',
            labelHelp: 'Navegue pelo calendário com as teclas de seta'
          }
        },
        activeUsers: 0,
        inactiveUsers: 0,
        isLoading: false,
        selectedCheckBox: [],
        fullPage: true,
        users: [],
        statements: [],
        totalRows: 1,
        totalCorporateRows: 1,
        selectedLang: 'pt',
        perPage: 15,
        currentPage: 1,
        isAdmin: false,
        result: '',
        resultExport: [],
        fields: [
          { key: 'corporateId', label: 'Cód', sortable: true, formatter: (value, key, item) => item.corporateId || item.accountId },
          { key: 'cnpj', label: 'CNPJ', sortable: false, thStyle: { width: '200px' } },
          { key: 'corporate.name', label: 'Nome', sortable: true, formatter: (value, key, item) => (item.corporate?.name || item.name) },
          { key: 'login', label: 'Login', sortable: true }
        ],
        statementTotal: '00:00:00',
        selectedFinalDate: null,
        selectedBeginDate: null,
        selected: 'user',
        filterUserFinancialText: '',
        accountId: 0,
        accountLogin: '',
        api: false
      };
    },
    async mounted () {
      await this.loadUserFinancialInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage) });
    },
    async created () {

    },
    methods: {
      getApiIconStyle (item) {
        if (item.api) {
          return doneIcon;
        }
      },
      onRowSelected (items) {
        this.selectedCheckBox = items;
        this.generateDataToExport();
      },
      filterCreatedDate () {
        if (this.selectedBeginDate && this.selectedFinalDate) {
          const beginDate = this.toUnixDayStart(this.selectedBeginDate);
          const finalDate = this.toUnixDayStart(this.selectedFinalDate);
          if (beginDate !== null && finalDate !== null) {
            return `${beginDate}|${finalDate}`;
          }
        } else {
          return null;
        }
      },
      normalizeDateInput (value) {
        if (!value) {
          return null;
        }
        if (typeof value === 'string') {
          return value.length > 10 ? value.substring(0, 10) : value;
        }
        if (value instanceof Date) {
          return moment(value).format('YYYY-MM-DD');
        }
        return moment(value).format('YYYY-MM-DD');
      },
      toUnixDayStart (value) {
        const normalized = this.normalizeDateInput(value);
        if (!normalized) {
          return null;
        }
        const parsed = moment(normalized + ' 00:00:00', 'YYYY-MM-DD HH:mm:ss', true);
        return parsed.isValid() ? parsed.unix() : null;
      },
      async onDateChange () {
        if (this.selectedBeginDate && this.selectedFinalDate) {
          this.generateDataToExport();
        }
      },
      async updateFinancialPage () {
        if (this.filterUserFinancialText) {
          await this.loadUserFinancialInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), user: this.filterUserFinancialText.trim().toLowerCase() });
        } else {
          await this.loadUserFinancialInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage) });
        }
      },

      async onUserFinancialSearchClick () {
        if (this.filterUserFinancialText) {
          await this.loadUserFinancialInfo({ perPage: parseInt(this.perPage), currentPage: 1, search: this.filterUserFinancialText.trim().toLowerCase() });
        } else {
          await this.loadUserFinancialInfo({ perPage: parseInt(this.perPage), currentPage: 1 });
        }
      },
      async loadUserFinancialInfo (params) {
        this.isLoading = true;
        const result = await userService.financialInfo(params);
        if (result && result.length > 0) {
          this.isAdmin = true;
          this.activeUsers = result[1] ? result[1].active : this.activeUsers;
          this.inactiveUsers = result[2] ? result[2].nonActive : this.inactiveUsers;
          this.users = result[0].elements;
          this.pageInfo = result[0].pageInfo;
          this.totalRows = this.pageInfo && this.pageInfo.length > 0 && this.pageInfo[0].count;
        }
        this.isLoading = false;
      },
      secondsToHour (seconds) {
        seconds = parseInt(seconds, 10);

        if (isNaN(seconds)) {
          throw new TypeError('Invalid value sent to convert-seconds');
        }
        var results = {};
        results.hours = Math.floor(seconds / 60 / 60);
        results.minutes = Math.floor((seconds / 60) % 60);
        results.seconds = Math.floor(seconds % 60);

        return `${String(results.hours).padStart(2, '0')}:${String(results.minutes).padStart(2, '0')}:${String(results.seconds).padStart(2, '0')}`;
      },

      async generateDataToExport (type) {
        const date = this.filterCreatedDate();
        const params = {
          perPage: 9999,
          currentPage: 1,
          date: date,
          type
        };

        this.resultExport = [];

        if (this.selectedCheckBox) {
          for (const user of this.selectedCheckBox) {
            if (user.corporateId) {
              const result = await storeService.extractByCorporate(user.corporateId, params);
              result[0].elements = result[0].elements.filter((item) => item.transactionType === 'D');
              this.resultExport.push(result);
            } else {
              Object.assign(params, { accountId: user.accountId });
              const userCreditInfo = await userService.statementUserCreditInfo(this.accountId, params);
              this.resultExport.push(userCreditInfo);
              for (const data of userCreditInfo[0].elements) {
                Object.assign(data, { login: user.login });
              }
            }
          }
        }

        let totalMinutes = 0;
        for (const conta of this.resultExport) {
          for (const element of conta[0].elements) {
            totalMinutes += element.mediaLength;
          }
        }

        this.statementTotal = this.secondsToHour(totalMinutes);
      },

      formatDate (value) {
        return moment.unix(value).format('YYYY/MM/DD');
      },

      formatTransaction (value) {
        return value === 'C' ? 'Crédito' : 'Débito';
      },

      formatDateDisplay (date) {
        const normalized = this.normalizeDateInput(date);
        return normalized ? moment(normalized, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';
      },

      async formatDataToExport ({ statementId, observation, created, mediaLength, login, transactionType }) {
        const formatedData = {};

        formatedData.Id = statementId;
        formatedData['Observação'] = observation;
        formatedData['Data de criação'] = moment.unix(created).format('DD/MM/YYYY');

        formatedData['Duração da mídia'] = this.secondsToHour(mediaLength);
        formatedData.Login = login;
        formatedData['Tipo da transação'] = this.formatTransaction(transactionType);

        return formatedData;
      },

      async exportData () {
        await this.generateDataToExport('exportFinancial');
        if (this.selectedCheckBox.length < 1) {
          return;
        }
        this.isLoading = true;

        const result = [];
        const resume = [];

        let totalTime = 0;

        for (let index = 0; index < this.resultExport.length; index++) {
          const statements = this.resultExport[index];
          const selected = this.selectedCheckBox[index] || {};
          const resumeUserData = {};
          let userLogin = '';
          let totalUserTime = 0;

          for (const statement of statements) {
            let dataAccountId = 0;

            for (const data of statement.elements) {
              if (data.accountId === dataAccountId && userLogin) {
                Object.assign(data, { login: userLogin });
              }
              totalUserTime += Number(data.mediaLength);
              const formatedData = await this.formatDataToExport(data);
              dataAccountId = data.accountId;
              userLogin = formatedData.Login;
              delete formatedData.accountId;
              result.push(formatedData);
            }
          }

          totalTime += totalUserTime;
          const corporateName = selected.corporate?.name;
          const resumeLabel = corporateName || selected.name || selected.login || userLogin;
          Object.assign(resumeUserData, { Cliente: resumeLabel });
          Object.assign(resumeUserData, { 'Total por usuário': this.secondsToHour(totalUserTime) });
          resume.push(resumeUserData);
        }
        resume.push({ Cliente: 'Total', 'Total por usuário': this.secondsToHour(totalTime) });

        if (this.resultExport && this.resultExport[0][0].elements.length > 0) {
          const workbook = xlsx.utils.book_new();

          var wscolsGeneral = [
            { width: 8 },
            { width: 45 },
            { width: 16 },
            { width: 16 },
            { width: 40 },
            { width: 17 }
          ];

          var wscolsResume = [
            { width: 40 },
            { width: 15 },
            { width: 8 }
          ];
          const worksheet = xlsx.utils.json_to_sheet(result);

          const worksheet2 = xlsx.utils.json_to_sheet(resume);
          worksheet['!cols'] = wscolsGeneral;
          worksheet2['!cols'] = wscolsResume;
          xlsx.utils.book_append_sheet(workbook, worksheet, 'Geral');
          xlsx.utils.book_append_sheet(workbook, worksheet2, 'Resumo');
          let fileName = 'financeiro.xlsx';
          if (this.selectedCheckBox.length === 1) {
            const selected = this.selectedCheckBox[0];
            const name = selected.corporate?.name || selected.name;
            fileName = `${name.replace(/\s/g, '_')}.xlsx`;
          } else if (this.selectedCheckBox.length > 1) {
            const user = JSON.parse(localStorage.getItem('user'));
            fileName = `${user.username.replace(/\s/g, '_')}.xlsx`;
          }

          xlsx.writeFile(workbook, fileName);
          this.isLoading = false;
        } else {
          this.isLoading = false;
          return [];
        }

        this.resultExport = [];
      }
    }
  };
</script>
<style>
.tab-content h3 {
  font-family: Poppins;
  color: #207BDD;
}

.filter-container {
  padding: 0 4px 4px 35px;
  margin-top: -4px
}

.searchColumn {
  width: 100%;
}

.searchContainer {
  width: 100%;
}

.filter-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  padding: 15px 0;
}

.column {
  flex-direction: column;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
}

.date-column,
.search-column,
.export-column {
  min-height: 80px;
}

.export-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.total-display {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.total-label {
  font-weight: 500;
  color: #6278A3;
}

.total-badge {
  background-color: #007bff;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.export-btn {
  min-width: 120px;
  padding: 8px 16px;
  font-size: 14px;
}

.column>form-group>label {
  text-align: center;
}

.tableContainer {
  padding: 35px;
}

.pagnation {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
}

.table {
  border-radius: 8px;
  background-color: #fff;
  color: #6278A3;
}

.modal-body {
  color: #6278A3;
  margin-left: 8px;
}

.modal-body h5 {
  color: #6278A3;
}

.modal-title {
  color: #6278A3;
}

.modal-body .btn-transparent {
  background-color: #e5e5e5;
  color: #007bff;
  font-weight: 500;
}

.modal-footer {
  justify-content: center;
}

.modal-footer>* {
  justify-content: space-between;
}

.modal-footer>button {
  justify-content: space-between;
}

.modal-footer .btn-transparent {
  background-color: #e5e5e5;
  color: #007bff;
  font-weight: 500;
  width: 114px;
  height: 34px;
}

.modal-footer .btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
  width: 114px;
  height: 34px;
}

.badge {
  margin-left: 10px;
  padding: 6px;
}

.selection-info {
  margin: 20px 35px;
  padding: 15px;
  background-color: #e8f4ff;
  border: 1px solid #007bff;
  border-radius: 8px;
  animation: fadeIn 0.3s ease-in-out;
}

.selection-indicator {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #007bff;
  font-size: 14px;
}

.selection-icon {
  color: #28a745;
  font-size: 18px;
}

.selection-text {
  font-weight: 600;
}

.selection-details {
  color: #6c757d;
  font-style: italic;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.generateXLS {
  padding: 5px 10px;
  border-radius: 4px;
  border: 0;
  cursor: pointer;
  background-color: #007bff;
}

.creditsBalance {
  text-align: left;
  color: #6278A3;
  font-family: Poppins;
  font-weight: 600;
  font-size: 14px;
}

.creditsBalanceRight {
  color: #6278A3;
  font-weight: 400;
  font-size: 14px;
}

.users-table {
  display: flex;
  flex-direction: column;
  gap: 5px;

  width: 100%;
  padding: 20px;
}
</style>
